module.exports = __webpack_public_path__ + "static/media/Group 43.13ddf935.png";